import Link from "next/link";
import { linkStyle } from "@/styles/sharedStyle";
import { css } from "@emotion/react";
import config from "@/libs/config";

export const BizsolRedirectLoginLink = () => {
  return (
    <Link href="/bizsol/redirect-login">
      <span css={linkStyle}>
        {config.BIZSOL_DISPLAY_NAME} IDでのログインはこちら
      </span>
    </Link>
  );
};
